
import { connect } from "react-redux";
import { PersonalInfoDashboard } from "./personal-info-dashboard";

const mapDispatchToProps = dispatch => {
  return {};
};

const mapStateToProps = state => {
  return {
    client: state.client,
    token: state.user.token,
    config: state.app.config,
    app: state.app,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfoDashboard);
